import React, { useState, useEffect } from "react";
import stylesheet from "./profile.module.css";
import Header from "../../webincludes/header";
import Footer from "../../webincludes/footer";
import Input from "../../component/input";
import Button from "../../component/button";


const Profile = () => {
    return (
        <>
            <div className={stylesheet.main_shop}>
                <div>
                    <Header />
                </div>
                <div className={`container-fluid ${stylesheet.product_side}`}>
                    <div className="row">
                        <div className={stylesheet.ShopCard_header}>
                            <div className="d-flex pl-5 pr-4 py-4">
                                <img src="https://img.icons8.com/material-outlined/20/f0cc00/left.png" />
                            </div>
                            <div className="d-flex align-items-center">
                                <h6>home</h6><h6 className={stylesheet.navigation_breaker}>.</h6><h6 className={stylesheet.header_current_page}>Shop</h6>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-12 ${stylesheet.category_section} px-5 pt-5`}>
                            <h1>Hello Taha</h1>
                        </div>
                        <div className={`col-lg-3 ${stylesheet.category_section} p-5`}>
                            <div className={stylesheet.category_listing}>
                                <h5>account info</h5>
                                <h5>Your address</h5>
                                <h5>Recent orders</h5>
                                <h5>Order history</h5>
                                <h5>Next</h5>
                            </div>
                        </div>
                        <div className={`col-lg-9 p-5 ${stylesheet.DetailListing}`}>
                            <h5>Your Information</h5>
                            <p className="mt-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sit amet vestibulum turpis.</p>
                            <div className="row">
                                <div className="col-lg-4">
                                    <Input placeholder={"Day"} type={"date"} />
                                </div>
                                <div className="col-lg-4">
                                    <Input placeholder={"Month"} type={"date"} />
                                </div>
                                <div className="col-lg-4">
                                    <Input placeholder={"Year"} type={"date"} />
                                </div>
                                <div className="col-lg-6">
                                    <Input placeholder={"Name *"} type={"text"} />
                                </div>
                                <div className="col-lg-6">
                                    <Input placeholder={"Surname *"} type={"text"} />
                                </div>
                                <div className="col-lg-12">
                                    <Input placeholder={"Your Email *"} type={"text"} />
                                </div>
                                <div className="col-lg-12 d-flex align-items-center justify-content-end">
                                    <Button value={"Save"} />
                                </div>
                            </div>

                            <div className="py-5">
                                <h5>Change password</h5>
                                <p className="mt-2"><b>password</b> 8 characters minimum length</p>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <Input placeholder={"Your Password *"} type={"password"} />
                                    </div>
                                    <div className="col-lg-6">
                                        <Input placeholder={"New Password (min 8 chars) *"} type={"password"} />
                                    </div>
                                    <div className="col-lg-6">
                                        <Input placeholder={"Confirm Password *"} type={"password"} />
                                    </div>
                                    <div className="col-lg-12 d-flex align-items-center justify-content-end">
                                        <Button value={"Save"} />
                                    </div>
                                </div>
                            </div>


                            <div className="py-5">
                                <h5>Delete account</h5>
                                <p className="mt-2">By deleting your account, your personal infoirmation will be permanently deleted. You will no longer be able to log into your profile and you will only be able to purchase as a guest or by creating a new account</p>
                                <div className="row">
                                    <div className="col-lg-12 d-flex align-items-center justify-content-end">
                                        <Button value={"Delete"} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div>
                <Footer />
            </div>
        </>
    )
}

export default React.memo(Profile)